import * as constants from "./constants";
import * as fields from "../../pages/customers/shared/edit/constants";
import { defaultReducers, defaultInitialState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAdvancedFilter, IBlockDataTabItem, IClassificationDataTabItem, ICreditDataTabItem, ICustomer, ICustomerEquipment, ISearchedCustomers, ISearchedEquipment, IState, IWholesalersTabItem } from "./_interfaces";


const initialState:IState = {
  ...defaultInitialState,
  [constants.CREDIT_DATA]: [],
  [constants.CREDIT_DATA_LOADING]: false,
  [constants.CREDIT_DATA_ITEMS_COUNT]: 0,
  [constants.CLASSIFICATION]: [],
  [constants.CLASSIFICATION_LOADING]: false,
  [constants.CLASSIFICATION_ITEMS_COUNT]: 0,
  [constants.BLOCK_DATA]: [],
  [constants.BLOCK_DATA_LOADING]: false,
  [constants.BLOCK_DATA_ITEMS_COUNT]: 0,
  [constants.WHOLESALERS]: [],
  [constants.WHOLESALERS_LOADING]: false,
  [constants.WHOLESALERS_ITEMS_COUNT]: 0,
  [constants.ADVANCED_FILTER]: [],
  [constants.ADVANCED_FILTER_LOADING]: false,
  [constants.ADVANCED_FILTER_ITEMS_COUNT]: 0,
  itemForEdit: {
    id: null,
    customers: [],
    [fields.GENERAL_INFO]: {
      [fields.CLASSIFICATION_TYPE_ID]: null,
      [fields.GENERAL_INFO_CUSTOMER_NUMBER]: '',
      [fields.GENERAL_INFO_CUSTOMER_NAME]: '',
      [fields.GENERAL_INFO_CUSTOMER_LONG_NAME]: null,
      [fields.GENERAL_INFO_CUSTOMER_EMAIL]: null,
      [fields.GENERAL_INFO_CUSTOMER_TELEPHONE]: null,
      [fields.GENERAL_INFO_LANGUAGE_ID]: null,
      [fields.GENERAL_INFO_DELIVERY_LEAD_TIME]: null,
      [fields.CONTACT_PERSON]: []
    },
    [fields.BILLING_ADDRESS]: {
      cityId: '',
      countryId: '',
      houseNumber: null,
      latitude: null,
      longitude: null,
      postalCode: null,
      regionId: '',
      street: null,
    },
    [fields.SHIP_TO_ADDRESS]: {
      cityId: '',
      countryId: '',
      houseNumber: null,
      latitude: null,
      longitude: null,
      postalCode: null,
      regionId: '',
      street: null,
    },
    [fields.CREDIT_DATA]: {
      bankAccount: '',
      vatNumber:  '',
      creditLimit: 0,
      creditExposure: 0,
      openBalance: 0,
    },
    [fields.COMMENTS]: null,
    [fields.WHOLESALERS]: [],
    partnerFunctionId: null,
    [fields.CUSTOMER_FILES]: [],
    [fields.HIERARCHY]: [],
    [fields.TERRITORIES]: [],
    [fields.ASSORTMENT]: {
      [fields.CUSTOMER_ASSORTMENT]: [],
    },
    [fields.BLOCK]: {
        [fields.BLOCK_ORDER]: null,
        [fields.BLOCK_DATE_UTC]: null,
    },
    [fields.CLASSIFICATION]: {
        [fields.CLASSIFICATION_SEGMENT_ID]: null,
        [fields.CLASSIFICATION_PAYER_NUMBER]: null,
        [fields.CLASSIFICATION_REBATE_NUMBER]: null,
        [fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID]: null,
        [fields.CLASSIFICATION_IS_WHOLESALER]: false,
        [fields.DIVISION_ID]: null,
        [fields.EXTERNAL_REFERENCE]: [],
    },
    equipmentTab: {
      customerEquipments: [],
      totalCount: 0,
    },
    createCustomerEquipments: [],
    deleteCustomerEquipments: [],
  },
  
  articlesError: null,
  equipmentLoading: false,
  searchedEquipment: [],
  searchedCustomers: [],
  searchedCustomersLoading: false,
};
const reducers = {
  ...defaultReducers,
  setCreditDataTabLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.CREDIT_DATA_LOADING] = action.payload;
  },
  setCreditDataTab: (state:IState, action:PayloadAction<{items:ICreditDataTabItem[], totalCount:number}>) => {
    state[constants.CREDIT_DATA] = action.payload.items;
    state[constants.CREDIT_DATA_ITEMS_COUNT] = action.payload.totalCount;
  },
  setClassificationDataTabLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.CLASSIFICATION_LOADING] = action.payload;
  },
  setClassificationDataTab: (state:IState, action:PayloadAction<{items:IClassificationDataTabItem[], totalCount:number}>) => {
    state[constants.CLASSIFICATION] = action.payload.items;
    state[constants.CLASSIFICATION_ITEMS_COUNT] = action.payload.totalCount;
  },
  setBlockDataTabLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.BLOCK_DATA_LOADING] = action.payload;
  },
  setBlockDataTab: (state:IState, action:PayloadAction<{items:IBlockDataTabItem[], totalCount:number}>) => {
    state[constants.BLOCK_DATA] = action.payload.items;
    state[constants.BLOCK_DATA_ITEMS_COUNT] = action.payload.totalCount;
  },
  setWholesalersTabLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.WHOLESALERS_LOADING] = action.payload;
  },
  setWholesalersTab: (state:IState, action:PayloadAction<{items:IWholesalersTabItem[], totalCount:number}>) => {
    state[constants.WHOLESALERS] = action.payload.items;
    state[constants.WHOLESALERS_ITEMS_COUNT] = action.payload.totalCount;
  },
  setAdvancedFilterLoading: (state:IState, action:PayloadAction<boolean>) => {
    state[constants.ADVANCED_FILTER_LOADING] = action.payload;
  },
  setAdvancedFilterTab: (state:IState, action:PayloadAction<{items:IAdvancedFilter[], totalCount:number}>) => {
    state[constants.ADVANCED_FILTER] = action.payload.items;
    state[constants.ADVANCED_FILTER_ITEMS_COUNT] = action.payload.totalCount;
  },




  countryFromRegionsFetchedShipToAddress: (state:IState, action:PayloadAction<string>) => {
    state.error = null;
    state.actionsLoading = false;
    state.itemForEdit.shipToAddress = { ...state.itemForEdit.shipToAddress, countryId: action.payload };
  },
  regionFromCityFetchedShipToAddress: (state:IState, action:PayloadAction<string>) => {
    state.error = null;
    state.actionsLoading = false;
    state.itemForEdit.shipToAddress = { ...state.itemForEdit.shipToAddress, regionId: action.payload };
  },
  countryFromRegionsFetchedBillToAddress: (state:IState, action:PayloadAction<string>) => {
    state.error = null;
    state.actionsLoading = false;
    state.itemForEdit.billToAddress = { ...state.itemForEdit.billToAddress, countryId: action.payload };
  },
  regionFromCityFetchedBillToAddress: (state:IState, action:PayloadAction<string>) => {
    state.error = null;
    state.actionsLoading = false;
    state.itemForEdit.billToAddress = { ...state.itemForEdit.billToAddress, regionId: action.payload };
  },
  startArticlesCall: (state:IState) => {
    state.articlesError = null;
    state.equipmentLoading = true;
  },
  setAssortmentArticles: (state:IState, action:PayloadAction<{
    data: {
      newItemValues: ICustomer,
    };
    items: ICustomerEquipment[];
    itemsCount: number;
  }>) => {
    state.equipmentLoading = false;
    state.itemForEdit = {
      ...action.payload.data.newItemValues,
      equipmentTab: {
        customerEquipments: action.payload.items,
        totalCount: action.payload.itemsCount,
      },
    };
  },
  resetCustomerEquipment: (state:IState) => {
    state.equipmentLoading = false;
    state.itemForEdit = {
      ...state.itemForEdit,
      equipmentTab: {
        customerEquipments: [],
        totalCount: 0,
      },
    };
  },
  deleteAssortmentArticles: (state:IState, action:PayloadAction<{
    deletedArticleIds: ICustomerEquipment[];
    addedArticles: ICustomerEquipment[];
    newArticles: ICustomerEquipment[];
    newItemValues: ICustomer;
  }>) => {
    state.itemForEdit = {
      ...action.payload.newItemValues,
      equipmentTab: {
        customerEquipments: action.payload.newArticles,
        totalCount: state.itemForEdit.equipmentTab.totalCount - 1,
      },
      createCustomerEquipments: action.payload.addedArticles,
      deleteCustomerEquipments: action.payload.deletedArticleIds,
    };
  },
  addAssortmentArticles: (state:IState, action:PayloadAction<{
    newArticleIds: ICustomerEquipment[];
    newArticles: ICustomerEquipment[];
    newItemValues: ICustomer;
  }>) => {
    state.itemForEdit = {
      ...action.payload.newItemValues,
      equipmentTab: {
        customerEquipments: action.payload.newArticles,
        totalCount: state.itemForEdit.equipmentTab.totalCount + 1,
      },
      createCustomerEquipments: action.payload.newArticleIds,
    };
  },
  setSearchArticles: (state:IState, action:PayloadAction<ISearchedEquipment[]>) => {
    state.searchedEquipment = action.payload;
  },
  resetSearchedItems: (state:IState, action:PayloadAction) => {
    state.searchedEquipment = [];
  },
  setSearchCustomers: (state:IState, action:PayloadAction<ISearchedCustomers[]>) => {
    state.searchedCustomers = action.payload;
  },
  setSearchCustomersLoading: (state:IState, action:PayloadAction<boolean>) => {
    state.searchedCustomersLoading = action.payload;
  }
};

export const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers,
});
